import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-formation',
  templateUrl: 'formation.html'
})
export class FormationPage {

  constructor(public navCtrl: NavController) {

  }

}



// WEBPACK FOOTER //
// ./src/pages/formation/formation.ts